import { HoldingWithInstrument } from "./HoldingWithInstrument";
import { TransactionWithInstrument } from "./TransactionWithInstrument";

export const FundEntityType = {
  Transaction: "Transaction",
  Holding: "Holding",
  TransactionWithInstrument: "TransactionWithInstrument",
  HoldingWithInstrument: "HoldingWithInstrument",
} as const;

export const FundEntityTypeKeys = Object.keys(FundEntityType);
